import { LABELS } from "../global/constants";
import { Toast } from "../components/Animations";

export const DialogMessage = ({text=LABELS.messageDialogMessage, animate=true}) => {
    if ( !text ) {
        return '';
    }

    const renderContent = () =>{
        return (
            <p className="dialog__message">
                { text }
            </p>
        )
    }

    return (
        animate ?
        <Toast customClass={`dialog__message-wrapper`}>
            { renderContent() }
        </Toast>
        : 
        <div className="dialog__message-wrapper">
            { renderContent() }
        </div>
    )
}